/*
    Component: serviceCaller
    Author: Derek Chan
    Description: Functional component that receives Api (UI Framework Object), serviceType (string), actionType (string), and a variable number of args for the backend
    execution. The component takes these params to call the correct backend service. It takes the 
    Props: { serviceType,
             argsObject
    }
*/

import * as OptionsService from '../services/OptionsService';
import * as TermsService from './TermsService';
import * as DashboardService from './DashboardService';
// import * as LoginService from "../../services/LoginService";
import * as AuditsService from './AuditsService';
import * as ManageService from './ManageService';
import getContents from '../services/ContentsService';
import Constants from '../constants/Constants';
import _ from 'lodash';

const serviceMap = {
  [Constants.GETOPTIONS_SERVICE_ID]: OptionsService.getOptions,
  [Constants.SAVEOPTIONS_SERVICE_ID]: OptionsService.saveOptions,
  [Constants.DELETEOPTIONSET_SERVICE_ID]: OptionsService.deleteOptionSet,
  [Constants.GETCONTENTS_SERVICE_ID]: getContents,
  [Constants.GETCLIENTS_SERVICE_ID]: DashboardService.getS3Clients,
  [Constants.SAVETERMS_SERVICE_ID]: TermsService.saveTerms,
  [Constants.GETTERMS_SERVICE_ID]: TermsService.getTerms,
  //'GETYEARS': DashboardService.getYearsAndTypes,
  [Constants.GETYEARSTYPES_SERVICE_ID]: DashboardService.getYearsAndTypes,
  [Constants.GETAUDITS_SERVICE_ID]: AuditsService.getAudits,
  [Constants.COPYOPTIONS_SERVICE_ID]: ManageService.copyOptions,
  [Constants.UPDATEDESC_SERVICE_ID]: ManageService.updateDesc,
  // 'LOGINSERVICE': LoginService.loginService,
  // 'GETORGID': LoginService.getOrgId
};

//props.serviceType determines which service to call
//props.argsObject holds the needed args for service call. argsObject must have the UI Framework Api Object
const ServiceCaller = (props) => {
  if (_.isNil(props.serviceType) || _.isNil(props.argsObject)) {
    let error = new Error('serviceType and argsObject CANNOT be undefined');
    console.log(error);
    return error;
  }

  if (serviceMap[props.serviceType]) {
    return serviceMap[props.serviceType](props.argsObject);
  } else {
    let error = new Error('SERVICE NOT FOUND');
    console.log(error);
    return error;
  }
};

export default ServiceCaller;
